module.exports = __webpack_public_path__ + "static/media/live_broadcast.1558afff.svg";